import React, { useState, useEffect } from "react";

const Timer = ({ duration }) => {
  const [timeLeft, setTimeLeft] = useState(duration);
  const [percentComplete, setPercentComplete] = useState(100);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeLeft((prevTimeLeft) => prevTimeLeft - 1);
    }, 1000);

    if (timeLeft === 0) {
      clearInterval(intervalId);
    }

    return () => clearInterval(intervalId);
  }, [timeLeft]);

  useEffect(() => {
    setPercentComplete((timeLeft / duration) * 100);
  }, [timeLeft, duration]);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div style={{ width: '20vw' }}>
        <div style={{ backgroundColor: '#252628' }}>
          <div
            style={{
              width: `${percentComplete}%`,
              height: "10px",
              backgroundColor: "#E1573A",
            }}
          ></div>
        </div>
      </div>
      <div style={{ fontWeight: '800', fontSize: '24px' }}>{formatTime(timeLeft)}</div>
    </div>
  );
};

export default Timer;
